/**
 * `snake_case` with an app prefix, matching the newer convention in the AutoCut
 * monorepo (`aea_app_started`, `aea_initialization_failed`).
 *
 * `exchange_first_open` is the "installed" metric: a ZXP install has no runtime
 * hook, so the first-ever panel open per OS user profile is the closest proxy.
 */
export const ExchangeEvent = {
  FirstOpen: 'exchange_first_open',
  PanelOpened: 'exchange_panel_opened',
  /** AutoCut was already on disk, so the download was skipped entirely. */
  AlreadyInstalled: 'exchange_already_installed',
  DownloadStarted: 'exchange_download_started',
  DownloadCompleted: 'exchange_download_completed',
  InstallerLaunched: 'exchange_installer_launched',
  Failed: 'exchange_failed',
  AutoClosed: 'exchange_auto_closed',
} as const satisfies Record<string, `exchange_${string}`>;

export type ExchangeEvent = (typeof ExchangeEvent)[keyof typeof ExchangeEvent];

export const FailureStep = {
  Bootstrap: 'bootstrap',
  Download: 'download',
  Launch: 'launch',
  Render: 'render',
  Unhandled: 'unhandled',
} as const;

export type FailureStep = (typeof FailureStep)[keyof typeof FailureStep];
